import clsx from 'clsx';
import { ReactNode } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { IconType } from './Chip';

export interface StateBlockProps {
    variant: 'empty' | 'error';
    /** Empty state only; the error state always shows a warning triangle. */
    icon?: IconType;
    title: string;
    body?: string;
    action?: ReactNode;
    /** 'h1' when the block is the whole page (no PageHeader above it). */
    heading?: 'h1' | 'h2';
}

/** Empty ("what to do next") and error ("try again") states, centred. */
export const StateBlock = ({ variant, icon, title, body, action, heading: Heading = 'h2' }: StateBlockProps) => {
    const Icon = variant === 'error' ? ExclamationTriangleIcon : icon;
    return (
        <div role={variant === 'error' ? 'alert' : undefined} className="flex flex-col items-center px-4 py-12 text-center">
            {Icon && (
                <span
                    className={clsx(
                        'mb-4 flex size-[4.5rem] items-center justify-center rounded-chip',
                        variant === 'error' ? 'bg-tone-danger-bg text-tone-danger-fg' : 'bg-sunken text-body'
                    )}
                >
                    <Icon className="size-10" aria-hidden="true" />
                </span>
            )}
            <Heading className="text-title text-strong">{title}</Heading>
            {body && <p className="mt-1 max-w-[40ch] text-small text-muted">{body}</p>}
            {action && <div className="mt-5">{action}</div>}
        </div>
    );
};
